export default {
  medications: {
    label: 'Pengobatan',
    filterTitle: 'Filter menurut status',
    search: 'Cari Obat',
    status: {
      draft: 'Minuman',
      active: 'Aktif',
      onHold: 'Tertahan',
      cancelled: 'Dibatalkan',
      completed: 'Lengkap',
      enteredInError: 'Dimasukkan Dalam Kesalahan',
      stopped: 'Berhenti',
      unknown: 'Tidak diketahui',
    },
    intent: {
      proposal: 'Usul',
      plan: 'Rencana',
      order: 'Memesan',
      originalOrder: 'Pesanan Asli',
      reflexOrder: 'Urutan Refleks',
      fillerOrder: 'Urutan Pengisi',
      instanceOrder: 'Urutan Instance',
      option: 'Pilihan',
    },
    priority: {
      routine: 'Rutin',
      urgent: 'Mendesak',
      asap: 'Secepat mungkin',
      stat: 'Stat',
    },
    filter: {
      all: 'Semua status',
    },
    requests: {
      label: 'Permintaan Obat',
      new: 'Minta Pengobatan',
      view: 'Lihat Obat',
      cancel: 'Batalkan Pengobatan',
      complete: 'Pengobatan Lengkap',
      error: {
        unableToRequest: 'Tidak dapat membuat permintaan Obat.',
        unableToComplete: 'Tidak dapat menyelesaikan permintaan Pengobatan.',
        quantityRequired: 'Kuantitas diperlukan.',
        unitRequired: 'Satuan wajib diisi.',
      },
    },
    medication: {
      medication: 'Pengobatan',
      for: 'Untuk',
      status: 'Status',
      intent: 'Maksud',
      priority: 'Prioritas',
      notes: 'Catatan',
      quantity: 'Kuantitas',
      quantityValue: 'Nilai',
      quantityUnit: 'Satuan',
      requestedOn: 'Diminta Pada',
      requestedBy: 'Diminta oleh',
      completedOn: 'Selesai Pada',
      canceledOn: 'Dibatalkan Pada',
      patient: 'Sabar',
    },
  },
}
